<div class="promo-popup" [class.is-active]="active">
    <div class="promo-popup__inner">
        <button class="promo-popup__back" type="button" (click)="closePopup()"><span>Back</span></button>
        <ng-content></ng-content>
    </div>
</div>
